import { Role, ROLES } from '../models';

export const ROLE_LIST: Role[] = [
    { role: ROLES.ADMIN, label: 'Admin', description: 'All contributors privileges, plus the ability to manage workspace and its users.' },
    { role: ROLES.CONTRIBUTOR, label: 'Contributor', description: 'Contributors can add and remove content from workspace.' },
    { role: ROLES.MEMBER, label: 'Member', description: 'Members can interact with workspace content.' },
];
